/* Waypoint, 2026-09-17. Rail behaviour for the header mega menu.
 *
 * One delegated listener for every panel on the page. Hovering or focusing a
 * rail item shows its pane and hides its siblings inside the same
 * <wpnt-mega-menu>.
 *
 * Rail items are links and clicks are NOT intercepted, so a click goes to the
 * collection. Every rail item owns a pane, including groups with no
 * sub-collections, so switching never leaves the previous group's contents on
 * screen.
 *
 * Visibility is toggled with the hidden attribute rather than inline styles so
 * the server-rendered default survives until JS runs and the panel is never
 * blank.
 */
(function () {
  'use strict';

  var SEL = '.wpnt-mm__rail-item[aria-controls]';

  function activate(item) {
    var root = item.closest('wpnt-mega-menu');
    if (!root) return;

    var paneId = item.getAttribute('aria-controls');
    if (!paneId) return;

    var pane = null;
    var panes = root.querySelectorAll('.wpnt-mm__pane');
    for (var i = 0; i < panes.length; i++) {
      if (panes[i].id === paneId) { pane = panes[i]; break; }
    }
    if (!pane) return;

    root.querySelectorAll(SEL).forEach(function (a) {
      a.setAttribute('aria-expanded', a === item ? 'true' : 'false');
    });
    for (var j = 0; j < panes.length; j++) {
      panes[j].hidden = panes[j] !== pane;
    }
  }

  function railItem(e) {
    if (!e.target || !e.target.closest) return null;
    return e.target.closest(SEL);
  }

  document.addEventListener('mouseover', function (e) {
    var item = railItem(e);
    if (item) activate(item);
  });

  document.addEventListener('focusin', function (e) {
    var item = railItem(e);
    if (item) activate(item);
  });

  /* When a panel closes, put it back to its first group so reopening it never
     shows whatever the last visitor happened to hover. */
  document.addEventListener('toggle', function (e) {
    var details = e.target;
    if (!details.matches || !details.matches('details.mega-menu') || details.open) return;
    details.querySelectorAll('wpnt-mega-menu').forEach(function (root) {
      var items = root.querySelectorAll(SEL);
      if (items.length) activate(items[0]);
    });
  }, true);
})();
